import { render, staticRenderFns } from "./TOOL_COMPANY_BASE.vue?vue&type=template&id=35d83e72"
import script from "./TOOL_COMPANY_BASE.vue?vue&type=script&lang=ts"
export * from "./TOOL_COMPANY_BASE.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports